import APTOS from "@assets/tokens/APT.svg?url";
import BTC from "@assets/tokens/BTC.svg?url";
import ENA from "@assets/tokens/ENA.svg?url";
import ETH from "@assets/tokens/ETH.svg?url";
import HYPE from "@assets/tokens/HYPE.svg?url";
import PUMP from "@assets/tokens/PUMP.svg?url";
import SOL from "@assets/tokens/SOL.svg?url";
import USDC from "@assets/tokens/USDC.svg?url";
import unknown from "@assets/tokens/unknownToken.svg?url";

export const TOKEN_LOGOS = {
  ETH,
  BTC,
  USDC,
  UNKNOWN: unknown,
  APTOS,
  PUMP,
  SOL,
  HYPE,
  ENA,
} as const;
